import apiRoutes from '../apiRoutes';
import { getCrmBonusesCount } from '../getCrmBonusesCount';
import { getList } from '../getList';

export const getRiskFreeBonusesList = (filter, platform) =>
  getList(filter, platform, apiRoutes.getRiskfreeList);

export const getRiskFreeBonusesCount = (filter = {}, platform) =>
  getCrmBonusesCount(filter, platform, apiRoutes.getRiskfreeCount);
